<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back">
        <mat-icon color="primary">arrow_back_ios</mat-icon>
    </button>
    <h3>{{ patient | patientHeading:'Task' }}</h3>
    <div>
        <button mat-icon-button *ngIf="editingTask && editingTask.id" (click)="deleteTask()" matTooltip="Delete Task">
            <mat-icon color="warn">delete</mat-icon>
        </button>
        <button mat-icon-button [disabled]="form.invalid" (click)="saveTask()" matTooltip="Save Task">
            <mat-icon [color]="form.invalid ? '' : 'primary'">save</mat-icon>
        </button>
    </div>
</mat-toolbar>

<div class="details-container">
    <form [formGroup]="form">
        <mat-card>
            <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="dateDatePicker" formControlName="date" placeholder="DD/MM/YYYY">
                <mat-datepicker-toggle matSuffix [for]="dateDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dateDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Due Date</mat-label>
                <input matInput [matDatepicker]="dueDateDatePicker" formControlName="dueDate" placeholder="DD/MM/YYYY"
                    [min]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="dueDateDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dueDateDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Task</mat-label>
                <input matInput formControlName="task">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Assigned to</mat-label>
                <mat-select formControlName="assigneeUserIds" multiple placeholder="Everyone">
                    <mat-option *ngFor="let member of members" [value]="member.userId">{{ member.name }}</mat-option>
                </mat-select>
                <mat-hint>Leave empty to assign to everyone in the practice.</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Notes</mat-label>
                <textarea matInput cdkTextareaAutosize="true" rows="10" formControlName="notes"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                    <mat-option *ngFor="let status of taskStatusOptions" [value]="status">
                        {{ status }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </mat-card>
    </form>
</div>